import type { LabelExtractor } from '@app/utils/addressTools'

export const extractAddressLabel: LabelExtractor = (place, kind, defaultValue) => {
  if (kind === 'house' || kind === 'street') return defaultValue
  return place.attributes.locality ?? defaultValue
}
